import { LitElement } from 'lit';

/**
 * dispatches a custom event to notify the outside of the component that the component has changed, and this event can
 * be used for external tools to trigger a change in the component for A/B testing.
 *
 * @param component {LitElement}
 */
export const exposeComponentChange = (component: LitElement) => {
  component.dispatchEvent(
    new CustomEvent('component-changed', {
      composed: true,
      bubbles: true,
    }),
  );
};
